import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'
import { FloatingSubmit } from '../UIUtilsFiles/FloatingSubmit'
import { ComponentQuestion } from '../UIUtilsFiles/ComponentQuestion'

function FillTheBlankText(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    isResetClick,
    initial,
    handleSucAndFailFeedback,
    onDisplayDoneClick,
    isPageRefresh
  } = props
  const {
    AnswerColorFill,
    AnswerFillColor,
    AnswerFontSize,
    Answers,
    BlankArray,
    ControlID,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Score,
    Priority,
    SequenceHint,
    TextAlign,
    FontStyle,
    Italic,
    Bold,
    QuestionText,
    QuestionFontSize
  } = mcData

  const [value, setValue] = useState({})
  const [validate, setValidate] = useState({})
  const [fillBlocks, setfillBlocks] = useState([])
  const [onBlurCall, setOnBlurCall] = useState(true)
  const [displayDone, setDisplayDone] = useState(false)

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlValue) {
          const { value, validate } = defaultValue.CtlValue
          setValue(value)
          setValidate(validate)
        }
        setOnBlurCall(false)
      } else {
        setValue({})
        setValidate({})
      }
    }
    if (Answers[0] !== '') {
      const answers = [...Answers]
      BlankArray.forEach((b) => {
        answers[b.Blank] = ''
      })
      setfillBlocks(answers)
    }
  }, [defaultValue, initial, onBlurCall])

  useEffect(() => {
    if (initial) {
      setOnBlurCall(true)
    }
  }, [initial])

  useEffect(() => {
    if (isResetClick) {
      fillBlocks &&
        fillBlocks.map((f, index) => {
          if (f === '') {
            document.getElementById(
              'box' + ControlID.toString() + index.toString()
            ).value = ''
          }
        })
      setOnBlurCall(true)
    }
  }, [isResetClick])

  useEffect(() => {
    if (isPageRefresh) {
      setOnBlurCall(true)
    }
  }, [isPageRefresh])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, validate)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let isCorrect = false
    if (Object.keys(validate).length === BlankArray.length) {
      for (const key in validate) {
        if (Object.prototype.hasOwnProperty.call(validate, key)) {
          if (validate[key]) {
            isCorrect = true
          } else {
            isCorrect = false
            break
          }
        }
      }
    }
    if (isCorrect) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  //Hide tick icon when activity is completed
  useEffect(() => {
    if (completed === 1 || !isActive) {
      setDisplayDone(false)
    }
  }, [completed, isActive])

  useEffect(() => {
    if (onDisplayDoneClick) {
      if (displayDone) {
        onDisplayDoneClick({ id: ControlID, displayDone: displayDone })
      } else {
        onDisplayDoneClick({ id: undefined, displayDone: displayDone })
      }
    }
  }, [displayDone])

  function textChange(b) {
    let valueCopy = JSON.parse(JSON.stringify(value))
    let blankArrayCopy = [...BlankArray]
    let validateCopy = { ...validate }
    Object.keys(valueCopy).forEach((key, index) => {
      const b = blankArrayCopy.find((b) => b.Blank === parseInt(key))
      if (b && b.Option[0] === valueCopy[key].replaceAll(' ', '^')) {
        validateCopy[key] = true
      } else {
        validateCopy[key] = false
      }
    })
    setValidate(validateCopy)

    if (validateCopy[blankArrayCopy[blankArrayCopy.indexOf(b)].Blank]) {
      handleSuccessChange(true)
    } else {
      handleSuccessChange(false)
    }
    if (isEmbeded) {
      setDisplayDone(true)
    } else {
      onAttemptChange(1)
      validateCorrectAnswer(false, validateCopy)
    }
  }

  function validateCorrectAnswer(timerValue, validateCopy) {
    let isCorrect = false
    if (Object.keys(validateCopy).length === BlankArray.length) {
      for (const key in validateCopy) {
        if (Object.prototype.hasOwnProperty.call(validateCopy, key)) {
          if (validateCopy[key]) {
            isCorrect = true
          } else {
            isCorrect = false
            break
          }
        }
      }
    }

    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (isCorrect) {
          onPriorityChange(Priority)
        }
      } else {
        if (Object.keys(validateCopy).length >= BlankArray.length) {
          onPriorityChange(Priority)
        }
      }
    }

    //validate for feedback
    if (Object.keys(validateCopy).length >= BlankArray.length) {
      if (isCorrect) {
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    }

    const controlList = {
      value: value,
      validate: validateCopy
    }

    if (isCorrect) {
      onValueChange(ControlID, controlList, Score, Score, '', timerValue)
    } else {
      onValueChange(ControlID, controlList, 0, Score, '', timerValue)
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
      style={{
        height: 'fit-content',
        marginBottom: isEmbeded ? undefined : '1%',
        marginTop: isEmbeded ? undefined : '2%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: TextAlign
          ? TextAlign === 'left'
            ? 'left'
            : TextAlign === 'right'
            ? 'right'
            : 'center'
          : 'left',
        padding: '5px'
      }}
    >
      {isEmbeded && QuestionText && (
        <ComponentQuestion
          QuestionText={QuestionText}
          FontStyle={FontStyle}
          Italic={Italic}
          Bold={Bold}
          QuestionFontSize={QuestionFontSize}
        />
      )}
      {isEmbeded && displayDone && (
        <FloatingSubmit
          submitClicked={() => {
            onAttemptChange(1)
            validateCorrectAnswer(false, validate)
            setOnBlurCall(true)
            setDisplayDone(false)
          }}
        />
      )}
      {fillBlocks &&
        fillBlocks.map((f, index) => {
          if (f === '') {
            const b = BlankArray && BlankArray.find((b) => b.Blank === index)
            let bLength = b.Option[0].replaceAll('^', ' ').length + 1
            return (
              <span key={index.toString()} style={{ marginBottom: '1%' }}>
                {isVerifyMode ? (
                  <p
                    style={{
                      minWidth: '50px',
                      width: 'fit-content',
                      height: '30px',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '10px',
                      backgroundColor: 'white',
                      margin: 0,
                      borderColor: '#0bff31',
                      borderWidth: '2px',
                      borderStyle: 'solid'
                    }}
                  >
                    {b.Option[0].replaceAll('^', ' ')}
                  </p>
                ) : (
                  <input
                    id={'box' + ControlID.toString() + index.toString()}
                    key={index.toString()}
                    autoComplete='off'
                    style={{
                      width: bLength + 'ch',
                      height: '30px',
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      borderRadius: '4px',
                      marginBottom: '1%',
                      borderColor: isVerifyMode
                        ? '#3EC986'
                        : value && value[index] && value[index] !== ''
                        ? isPractice || completed === 1 || !isActive
                          ? validate[b.Blank]
                            ? '#3EC986'
                            : '#ff551f'
                          : '#B5B5B5'
                        : '#B5B5B5',
                      backgroundColor: AnswerFillColor,
                      color: AnswerColorFill,
                      fontFamily: FontStyle,
                      fontStyle: Italic === 'True' ? 'italic' : 'normal',
                      fontWeight: Bold === 'True' ? 'bold' : 'normal',
                      fontSize:
                        AnswerFontSize === 'SMALL'
                          ? SMALL_DESKTOP
                          : AnswerFontSize === 'LARGE'
                          ? LARGE_DESKTOP
                          : MEDIUM_DESKTOP,
                      animationName:
                        isPractice || completed === 1
                          ? value && value[index] && value[index] !== ''
                            ? validate[b.Blank]
                              ? 'pulse_animation'
                              : 'shake_animation'
                            : 'unset'
                          : value && value[index] && value[index] !== ''
                          ? 'flip_animation'
                          : 'unset'
                      // animationDuration: '200ms'
                    }}
                    onBlur={() => {
                      if (completed === 0) {
                        textChange(b)
                      }
                    }}
                    defaultValue={
                      isResetClick
                        ? ''
                        : value[index] && value[index].toString()
                    }
                    onChange={(e) => {
                      let valueCopy = JSON.parse(JSON.stringify(value))
                      valueCopy[index] = e.target.value
                      setValue(valueCopy)
                    }}
                    readOnly={
                      explanationClick
                        ? true
                        : completed === 1 || !isActive
                        ? true
                        : isPractice
                        ? followTheFlow
                          ? validate[b.Blank] && currentPriority > Priority
                            ? true
                            : false
                          : false
                        : false
                    }
                    disabled={
                      explanationClick
                        ? true
                        : completed === 1 || !isActive
                        ? true
                        : isPractice
                        ? followTheFlow
                          ? validate[b.Blank] && currentPriority > Priority
                            ? true
                            : false
                          : false
                        : false
                    }
                    onKeyDown={(ev) => {
                      if (ev.key === 'Enter') {
                        ev.target.blur()
                      } else if (ev.key === 'ArrowDown') {
                        ev.target.blur()
                      }
                    }}
                  />
                )}
              </span>
            )
          } else {
            let replaceBlank = f.replaceAll('^', '  ')
            return (
              <p
                key={index.toString()}
                style={{
                  fontSize:
                    AnswerFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : AnswerFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  marginRight: '1%',
                  marginLeft: '1%',
                  marginBottom: '1%',
                  color: AnswerColorFill,
                  fontFamily: FontStyle,
                  fontStyle: Italic === 'True' ? 'italic' : 'normal',
                  fontWeight: Bold === 'True' ? 'bold' : 'normal'
                }}
              >
                {' ' + replaceBlank + ' '}
              </p>
            )
          }
        })}
    </div>
  )
}

export default FillTheBlankText
